import script from "./AlertRecuseTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertRecuseTerms.vue?vue&type=script&setup=true&lang=js"

import "./AlertRecuseTerms.vue?vue&type=style&index=0&id=11bac7e1&lang=scss"

const __exports__ = script;

export default __exports__